import { BasicClient } from '@/utils/httpClient'

export default class Search {
  limit: number
  page: number
  client: BasicClient
  constructor() {
    this.client = new BasicClient()
  }
  searchEmployees(limit, page, params): any {
    var paginado = '?pagination=' + limit + ',' + page + ',0'
    return this.client.exec(
      '/OnBoarding/UserOnBoarding' + paginado,
      'GET',
      params
    )
  }
  SearchEmployee(filter) {
    return this.client.exec('/v2/admin-mod/users/search', 'GET', { filter })
  }
  searchSector(): any {
    return this.client.exec('/users/retrieveSector', 'GET')
  }
  searchLocacion(): any {
    return this.client.exec('/users/retrieveLocation', 'GET')
  }
  Aprove(id): any {
    return this.client.exec('/OnBoarding/AproveOnBoarding', 'POST', {
      iduser: id,
    })
  }
  SearchEforms(entity, filters) {
    return this.client.exec('/search/documento', 'POST', {
      entity: entity,
      filters: filters,
    })
  }
  SearchUsuario(entity, filters) {
    return this.client.exec(`/search/${entity}`, 'POST', {
      filters: filters,
    })
  }
  DownloadZip(documentsId) {
    return this.client.downloadFile(
      '/v2/admin-mod/documents/downloadFilesAsZip',
      {
        documentsId,
      }
    )
  }
  DownloadExcel(filters, params) {
    return this.client.downloadFile(
      `/v2/admin-mod/documents/download?${params}`,
      filters
    )
  }
  DownloadExcelObservations(filters, params) {
    return this.client.downloadFile(
      `/v2/admin-mod/documents/observations/download?${params}`,
      filters
    )
  }
  SearchDocuments(filters, params) {
    return this.client.exec(
      `/v2/admin-mod/documents/search?${params}`,
      'POST',
      filters
    )
  }
  ResultEforms(filters) {
    return this.client.exec(
      '/v2/admin-mod/documents/filtersEforms',
      'POST',
      filters
    )
  }
  DownloadMetadata(eformExport) {
    return this.client.downloadFile(
      `/v2/admin-mod/documents/downloadMetadata`,
      eformExport
    )
  }
  SearchEmployeesToReport(params) {
    return this.client.exec(`/v2/admin-mod/users/reportto?${params}`, 'GET')
  }
  DocumentMassiveCancel(params){
    return this.client.exec(`/v2/admin-mod/documents/massivecancel`, 'POST', {
      ids: params
    })
  }
  BackupDocuments(){
    return this.client.exec(`/scheduler/v2/backup`, 'POST')
  }

  getProcessList(params) {
    return this.client.exec(`/search/schedulermultipliers`, 'POST', params)
  }

  getProcessResults(perPage, page, body) {
    return this.client.exec(`/search/scheduler?pagination=${perPage},${page},0`, 'POST', body)
  }

  getDocumentDetail(documentId) {
    if (!documentId) return Promise.reject('No documentId provided')
    return this.client.exec(`/v2/admin-mod/documents/details/${documentId}`, 'GET')
  }
}
